module.exports = __webpack_public_path__ + "assets/img/contact.c2fe2a8f.png";